import { render, staticRenderFns } from "./MemberListCreatorLayout.vue?vue&type=template&id=38a33198&scoped=true"
import script from "./MemberListCreatorLayout.vue?vue&type=script&lang=js"
export * from "./MemberListCreatorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a33198",
  null
  
)

export default component.exports